import { Map } from 'immutable'
import {
  SET_TERMS_PROCESSING,
  SET_TERMS_DATA,
  SET_TERMS_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_TERMS_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_TERMS_DATA:
      return state
        .setIn(['data'], payload.data)
        .setIn(['processing'], false)
    case SET_TERMS_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
